import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Inserate.css';
import NamedLink from '../NamedLink/NamedLink';

const Inserate = props => {
    const { rootClassName, className } = props;
    const classes = classNames(rootClassName || css.root, className);

    // prettier-ignore
    return (
    <div className={classes}>
    <p className={css.lastUpdated}>Aktualisiert am 15.10.2025</p>
    <h2 className={css.heading}>Richtlinien für Pferde-Profile</h2>

    <p>Ohne gegenseitiges Vertrauen kann unsere Community nicht funktionieren. Vertrauen setzt Spielregeln voraus, an welche sich alle halten. Bitte lies dir nachfolgende Richtlinien genau durch, bevor Du dein Pferd als Profil zu HorseDeal hinzufügst.</p>

    <p>Ergänzend zu diesen Richtlinien für Pferde-Profile gelten die folgenden Grundlagen:</p>  

    <ul className={css.nonNumberedList}>
      <li><NamedLink name="TermsOfServicePage">Verhaltenskodex</NamedLink></li>
      <li><NamedLink name="GuidlinePage">Community-Richtlinien</NamedLink></li>
      <li><NamedLink name="KodexPage">Allgemeinen Geschäftsbedingungen</NamedLink></li>
    </ul>  

    <p>Ein Pferde-Profil, das bei HorseDeal veröffentlicht wird, muss:</p>

    <h2>1. Ein Pferd sein</h2>

    <p>Auf unserer Plattform kannst Du dein Pferd als Profil hinzufügen, wenn Du auf der Suche nach eine kurzfristigen Aushilfe oder einer langfristiger Beteiligung bist. Jegliche Art von Produkten und Dienstleistungen können nicht veröffentlicht werden.</p>
  
    <h2>2. Im eigenen Namen erstellt werden</h2>

    <p>Ein Pferd darf nur von der Pferdebesitzer:in oder dem Pferdebesitzer und im eigenen Namen d.h. nicht für Dritte erstellt werden.</p>
  
    <h2>3. Eindeutig und wahr sein</h2>

    <p>Alle Angaben zum Pferd müssen der Wahrheit entsprechen. Die Beschreibung darf keine irreführenden oder falschen Informationen enthalten und muss unseren <NamedLink name="GuidlinePage">Community-Richtlinien</NamedLink> entsprechen.</p>
  
    <h2>4. Einzeln veröffentlicht werden</h2>
    <p>Du musst jedes Pferd einzeln als Profil hinzufügen und darfst nicht mehrere Pferde als Paketangebot bündeln. Ein Pferd darf nur einmal als Profil erstellt und veröffentlicht werden, auch wenn es bereits von jemand anderem veröffentlicht wurde.</p>
  
    <h2>5. Original-Fotos zeigen</h2>
    <p>Du verfügst über die erforderlichen Bildrechte und deine hochgeladen Fotos und Videos dürfen nicht irreführend sein oder falsche Darstellungen enthalten.</p>
    <p>Wir verbieten insbesondere:</p>
    <ul style={{  paddingLeft: '30px' }}>
        <li>Fotos und Videos, die stark verzerrt sind oder digitale Effekte enthalten, so dass nicht klar erkennbar ist, dass es sich um ein Pferd handelt.</li>
        <li>Einblendungen von Symbolen, Icons, Rahmen, oder Aufklebern auf deinen Fotos oder in deinen Videos, welche nicht in unserem Kontext stehen.</li>
        <li>Memes, Fotos oder Videos, die mehrheitlich aus Text bestehen.</li>
    </ul>

    <p>Wir behalten uns das Recht vor, ein Pferde-Profil abzulehnen, wenn die hochgeladenen Fotos und Videos eine schlechte Auflösung aufweisen.</p>
  
    <h2>Zuwiderhandlungen</h2>
    <p>Wir behalten uns vor, Pferde-Profile zu ändern, abzulehnen oder zu löschen, die o.g. Regeln nicht erfüllen und - im Wiederholungsfalle - gegen und / oder Massnahmen gegen dein Konto zu ergreifen, ohne, dass dir hieraus Ansprüche gegenüber uns erwachsen. Dies gilt ebenfalls für die Rückzahlung bereits erworbener Leistungen.</p>
    <h2>Änderungen</h2>
    <p>Wir behalten uns das Recht vor, jederzeit Änderungen an den vorliegenden Richtlinien vorzunehmen.</p>
    </div>
  );
};

const { string } = PropTypes;

Inserate.propTypes = {
    rootClassName: string,
    className: string,
};

export default Inserate;
